import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './Contact.css';

const LINKS = [
  { key: 'instagram_url', label: 'INSTAGRAM', sub: '', icon: '↗' },
  { key: 'linkedin_url', label: 'LINKEDIN', sub: '', icon: '↗' },
  { key: 'email', label: 'ashutosh_karmakar@yahoo.com', sub: '', icon: '↗', isEmail: true },
  { key: 'resume_url', label: 'RESUME', sub: '', icon: '↗' },
];

export default function Contact() {
  const [settings, setSettings] = useState({});
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  useEffect(() => {
    supabase
      .from('site_settings')
      .select('key, value')
      .then(({ data }) => {
        if (!data) return;
        const map = {};
        data.forEach(r => { map[r.key] = r.value; });
        setSettings(map);
      });
  }, []);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setStatus('sending');
    const { error } = await supabase
      .from('contact_messages')
      .insert([{ name: form.name, email: form.email, message: form.message }]);
    if (error) {
      setStatus('error');
    } else {
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    }
  };

  return (
    <main className="contact">
      <div className="contact__body">
        {/* Links */}
        <section className="contact__links-section">
          <p className="contact__links-label">You can also see my work in...</p>
          <div className="contact__links">
            {LINKS.map(({ key, label, sub, icon, isEmail }) => {
              const val = settings[key];
              const href = isEmail ? `mailto:${val}` : val;
              return (
                <a
                  key={key}
                  href={href || '#'}
                  target={isEmail ? '_self' : '_blank'}
                  rel="noreferrer"
                  className="contact__link"
                >
                  <span className="contact__link-label">
                    {label}
                    {sub && <span className="contact__link-sub"> {sub}</span>}
                  </span>
                  <span className="contact__link-icon">{icon}</span>
                </a>
              );
            })}
          </div>
        </section>

        {/* Contact form */}
        <section className="contact__form-section">
          <p className="contact__form-label">Or send me a message directly</p>
          {status === 'sent' ? (
            <div className="contact__success">
              <span>✓</span>
              <p>Message sent! I'll get back to you soon.</p>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <div className="contact__field">
                <label className="contact__field-label">Name</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="contact__input"
                  placeholder="Your name"
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__field-label">Email</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  className="contact__input"
                  placeholder="your@email.com"
                  required
                />
              </div>
              <div className="contact__field">
                <label className="contact__field-label">Message</label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className="contact__textarea"
                  placeholder="Tell me about your project..."
                  rows={5}
                  required
                />
              </div>
              {status === 'error' && (
                <p className="contact__error">Something went wrong. Please try again.</p>
              )}
              <button
                type="submit"
                className="contact__submit"
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'SENDING...' : 'SEND MESSAGE ↗'}
              </button>
            </form>
          )}
        </section>
      </div>

      {/* Page nav */}
      <div className="contact__page-nav">
        <Link to="/about" className="contact__page-nav-item">← ABOUT</Link>
        <Link to="/" className="contact__page-nav-item">HOME →</Link>
      </div>
    </main>
  );
}
